import { Divider, Paper } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { LuMail, LuPhone, LuPlane } from 'react-icons/lu';
import { WsColors } from 'wisestep-base';

import { pipelineEmptyValues } from '../../../features/jobsCrm/components/helper/JobCrmEmptyValues';
import AdvancedFiltersHeader from '../../../utils/AdvancedFiltersHeader';
import { NoticePeriod, SalaryRangeFilter, SourceFilter, TagsFilter } from '../components';
import { contactPreferences, workAuthorization } from '../components/AdvanceFilterHelper';
import BusinessDefinitionFilter from '../components/BusinessDefinitionFilter';
import CheckboxListFilter from '../components/CheckboxListFilter';
import RecruiterAutoCompleteInputFilter from '../components/RecruiterAutoCompleteInputFilter';
import RelocationPreferenceFilter from '../components/RelocationPreferenceFilter';
import JobsCrmPipelineAdvanceFiltersFormProps from '../models/JobsCrmPipelineAdvanceFiltersFormProps';
import JobsCrmPipelineAdvanceFiltersProps from '../models/JobsCrmPipelineAdvanceFiltersProps';

const WsJobsCrmPipelineAdvanceFiltersNew = ({
  onApplyFilters,
  defaultValues,
}: JobsCrmPipelineAdvanceFiltersProps) => {
  const methods = useForm<JobsCrmPipelineAdvanceFiltersFormProps>({ defaultValues });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const resetDefault = () => onApplyFilters({ ...pipelineEmptyValues });

  const onFormSubmit = (data: JobsCrmPipelineAdvanceFiltersFormProps) => onApplyFilters(data);

  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(onFormSubmit)}
          onReset={resetDefault}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <TagsFilter name="tags" defaultValue={defaultValues?.tags} showAccordionIcon={true} />
            <BusinessDefinitionFilter
              name="currentStageCurrentStatusPairs"
              showAccordionIcon={true}
            />
            <RelocationPreferenceFilter name="relocationPreferences" showAccordionIcon={true} />
            <SalaryRangeFilter showAccordionIcon={true} />
            <CheckboxListFilter
              name="workAuthorization"
              options={workAuthorization}
              title="Work Authorization"
              startIcon={<LuPlane color={WsColors.TertiaryShades800} />}
            />
            <SourceFilter
              name="source"
              defaultValue={defaultValues?.source}
              showAccordionIcon={true}
            />
            <CheckboxListFilter
              name="commPreferences"
              options={contactPreferences}
              title="Communication Preference"
              startIcon={<LuMail color={WsColors.TertiaryShades800} />}
            />
            <CheckboxListFilter
              name="contactAvailability"
              options={contactPreferences}
              title="Contact Availability"
              startIcon={<LuPhone color={WsColors.TertiaryShades800} />}
            />
            <NoticePeriod name="noticePeriod" showAccordionIcon={true} />
            <RecruiterAutoCompleteInputFilter
              name="createdBy"
              title="CreatedBy"
              showAccordionIcon={true}
            />
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};
export default WsJobsCrmPipelineAdvanceFiltersNew;
